import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CardIcon extends Vue {
    @Prop({ default: 'default' })
    type: string;
}
